// import React, { useState, useEffect, useRef } from "react";
// import { collection, getDocs, query } from "firebase/firestore";
// import { useParams, useLocation } from "react-router-dom";
// import YouTube from "react-youtube";
// import css from "./hero.module.css";
// import arrowImp from "../../img/arrowDownPick.png";
// import arrowLeft from "../../img/arrowInHerpLeft.png";
// import arrowRight from "../../img/arrowInHeroRight.png";
// import { db } from "../../firebase";
// import Footer from "../standartComponent/footer/footer";
// import LitShow from "../standartComponent/litShow/litShow";
// import ProductForHero from "./productForHero";

// export default function Author({ windowDimensions }) {
//   const [products, setProducts] = useState([]);
//   const [heroes, setHeroes] = useState([]);
//   const [selectedHero, setSelectedHero] = useState(null);

//   const location = useLocation();
//   const { id } = useParams();

//   const scrollRef = useRef(null);
//   const heroNameRef = useRef(null);

//   // Скрол дозволяємо тільки після ручного вибору автора
//   const shouldScrollAfterSelect = useRef(false);

//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, [location]);

//   useEffect(() => {
//     const fetchHeroes = async () => {
//       try {
//         const heroesRef = collection(db, "author");
//         const querySnapshot = await getDocs(heroesRef);
//         const heroData = querySnapshot.docs.map((doc) => doc.data());

//         setHeroes(heroData);

//         if (heroData.length === 0) return;

//         if (!id) {
//           // Перший автор підтягується автоматично, але без скролу
//           setSelectedHero(heroData[0]);
//         } else {
//           const selected = heroData.find((hero) => hero.uid === id);

//           // Автор з URL теж підтягується без автоматичного скролу
//           setSelectedHero(selected || heroData[0]);
//         }
//       } catch (error) {
//         console.error("Помилка отримання авторів:", error);
//       }
//     };

//     fetchHeroes();
//   }, [id]);

//   const scrollToSelectedHero = (hero) => {
//     if (!hero) return;

//     requestAnimationFrame(() => {
//       // Горизонтальний скрол списку авторів
//       if (scrollRef.current) {
//         const selectedElement = scrollRef.current.querySelector(
//           `[data-uid='${hero.uid}']`,
//         );

//         if (selectedElement) {
//           selectedElement.scrollIntoView({
//             behavior: "smooth",
//             block: "nearest",
//             inline: "center",
//           });
//         }
//       }

//       // Вертикальний скрол саме до імені автора
//       if (heroNameRef.current) {
//         const top =
//           heroNameRef.current.getBoundingClientRect().top +
//           window.pageYOffset -
//           200;

//         window.scrollTo({
//           top,
//           behavior: "smooth",
//         });
//       }
//     });
//   };

//   const handleHeroSelect = (hero) => {
//     if (!hero) return;

//     // Якщо користувач натиснув на вже вибраного автора,
//     // selectedHero не зміниться, тому запускаємо скрол вручну
//     if (selectedHero?.uid === hero.uid) {
//       scrollToSelectedHero(hero);
//       return;
//     }

//     shouldScrollAfterSelect.current = true;
//     setSelectedHero(hero);
//   };

//   useEffect(() => {
//     if (!selectedHero) return;

//     // Якщо автора вибрало автоматично при першому завантаженні — не скролимо
//     if (!shouldScrollAfterSelect.current) return;

//     scrollToSelectedHero(selectedHero);

//     shouldScrollAfterSelect.current = false;
//   }, [selectedHero]);

//   useEffect(() => {
//     if (selectedHero?.name) {
//       const fetchProducts = async () => {
//         try {
//           const q = query(collection(db, "product"));
//           const querySnapshot = await getDocs(q);

//           const allProducts = querySnapshot.docs.map((doc) => doc.data());

//           const selectedNameFirstWord = selectedHero.name
//             .split(" ")[0]
//             .toLowerCase();

//           const filtered = allProducts.filter((product) => {
//             const autor = product.textAutor;

//             if (typeof autor !== "string") {
//               console.warn("⚠️ Пропущено товар з невалідним textAutor:", autor);
//               return false;
//             }

//             const productFirstWord = autor.split(" ")[0].toLowerCase();
//             const isMatch = productFirstWord === selectedNameFirstWord;

//             return isMatch;
//           });

//           setProducts(filtered);
//         } catch (error) {
//           console.error("❌ Помилка отримання книг автора:", error);
//         }
//       };

//       fetchProducts();
//     }
//   }, [selectedHero]);

//   const scrollLeft = () =>
//     scrollRef.current?.scrollBy({ left: -300, behavior: "smooth" });

//   const scrollRight = () =>
//     scrollRef.current?.scrollBy({ left: 300, behavior: "smooth" });

//   return (
//     <div>
//       <div className={css.allBooksWrap}>
//         <div className={css.allHero}>
//           <p className={css.yourPerfectHero}>
//             Майстри, яких представляє видавництво “Час майстрів”
//             <br />
//             <span className={css.yourPerfectHeroSpan}>
//               відкриті до безпосереднього спілкування з дітьми, батьками та
//               спеціалістами
//             </span>
//           </p>

//           <div className={css.ageWrap}>
//             <div className={css.chousBooksSelect}>
//               <select
//                 className={css.customSelect}
//                 value={
//                   selectedHero
//                     ? heroes.findIndex((hero) => hero.uid === selectedHero.uid)
//                     : ""
//                 }
//                 onChange={(e) => {
//                   const hero = heroes[Number(e.target.value)];
//                   handleHeroSelect(hero);
//                 }}
//               >
//                 {heroes.map((hero, index) => (
//                   <option key={index} className={css.customOpin} value={index}>
//                     {hero.name}
//                   </option>
//                 ))}
//               </select>

//               <img
//                 src={arrowImp}
//                 className={css.customArrowSelect}
//                 alt="Arrow"
//               />
//             </div>
//           </div>
//         </div>

//         <div className={css.autorListSmal}>
//           <img
//             src={arrowLeft}
//             onClick={scrollLeft}
//             className={css.arrowLeftSt}
//             alt="Scroll Left"
//           />

//           <div className={css.autorListSmalNew} ref={scrollRef}>
//             {heroes.map((hero, index) => (
//               <div
//                 key={index}
//                 data-uid={hero.uid}
//                 onClick={() => handleHeroSelect(hero)}
//                 className={css.imgAutorWrapSmall}
//               >
//                 <img
//                   src={hero.foto}
//                   className={`${css.imgAutorSmall} ${
//                     selectedHero?.uid === hero.uid ? css.selectedHeroImage : ""
//                   }`}
//                   alt={hero.name}
//                 />

//                 <p className={css.autorNameM}>{hero.name}</p>
//                 <p className={css.autorNameMSma}>{hero.book}</p>
//                 {/* <p className={css.autorNameMbigCol}>{hero.descSecond}</p> */}
//               </div>
//             ))}
//           </div>

//           <img
//             src={arrowRight}
//             onClick={scrollRight}
//             className={css.arrowRightSt}
//             alt="Scroll Right"
//           />
//         </div>
//       </div>

//       {selectedHero && (
//         <div className={css.wrapHeroBigFoto}>
//           <div className={css.wrapHeroBigFotoTwo}>
//             <div className={css.imgAutorWrapBig}>
//               <img
//                 src={selectedHero.foto}
//                 className={css.imgAutorBig}
//                 alt="Author"
//               />
//             </div>

//             <div className={css.descHeroOP}>
//               <h1 className={css.heroName} ref={heroNameRef}>
//                 {selectedHero.name}
//               </h1>

//               <p className={css.dotP}>{selectedHero.descOne}</p>
//               <p className={css.dotP}>{selectedHero.descSecond}</p>

//               <p className={css.whatBook}>
//                 {selectedHero.autor}&nbsp; {selectedHero.book}
//               </p>
//             </div>
//           </div>

//           <div className={css.yellowFitchWrap}>
//             <p className={css.yellowFitchWrapP}>{selectedHero.smallDesc}</p>
//             <div className={css.hvist}></div>
//           </div>

//           <div className={css.historiCreateBlock}>
//             <p className={css.hictoryP}>{selectedHero.history}</p>
//           </div>

//           <div className={css.blockInturv}>
//             <div className={css.blockInturvSmall}>
//               <h3 className={css.inturvH3}>Інтерв’ю з автором</h3>
//               <p className={css.inturvP}>{selectedHero.internOne}</p>
//               <p className={css.inturvP}>{selectedHero.internSecond}</p>
//             </div>
//           </div>
//         </div>
//       )}

//       <div className={css.theSameBooksWrap}>
//         <div className={css.theSameBooksWrapSmall}>
//           <h4 className={css.theSameH4}>Книги автора</h4>

//           <div className={css.smallBookLikeWrap}>
//             {products.slice(0, 3).map((el, index) => (
//               <ProductForHero el={el} key={index} />
//             ))}
//           </div>
//         </div>
//       </div>

//       <div className={css.videoBlockWrap}>
//         <div className={css.videoBlockWrapSmall}>
//           <h4 className={css.seeBook}>Відеознайомство</h4>

//           <div className={css.video}>
//             {selectedHero?.video && (
//               <YouTube
//                 videoId={selectedHero.video}
//                 opts={{ width: "1193.03px", height: "714.56px" }}
//               />
//             )}
//           </div>
//         </div>
//       </div>

//       <LitShow />
//       <Footer />
//     </div>
//   );
// }

import React, { useState, useEffect, useRef } from "react";
import { collection, getDocs } from "firebase/firestore";
import { useParams, useLocation } from "react-router-dom";
import YouTube from "react-youtube";
import css from "./hero.module.css";
import arrowImp from "../../img/arrowDownPick.png";
import arrowLeft from "../../img/arrowInHerpLeft.png";
import arrowRight from "../../img/arrowInHeroRight.png";
import { db } from "../../firebase";
import Footer from "../standartComponent/footer/footer";
import LitShow from "../standartComponent/litShow/litShow";
import ProductForHero from "./productForHero";
import { isProductVisible } from "../../function/productVisibility";
export default function Author({ windowDimensions }) {
  const [products, setProducts] = useState([]);
  const [heroes, setHeroes] = useState([]);
  const [selectedHero, setSelectedHero] = useState(null);

  const location = useLocation();
  const { id } = useParams();

  const scrollRef = useRef(null);
  const heroNameRef = useRef(null);

  // Скрол дозволяємо тільки після ручного вибору автора
  const shouldScrollAfterSelect = useRef(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  useEffect(() => {
    const fetchHeroes = async () => {
      try {
        const heroesRef = collection(db, "author");
        const querySnapshot = await getDocs(heroesRef);
        const heroData = querySnapshot.docs.map((doc) => doc.data());

        setHeroes(heroData);

        if (heroData.length === 0) return;

        if (!id) {
          // Перший автор підтягується автоматично, але без скролу
          setSelectedHero(heroData[0]);
        } else {
          const selected = heroData.find((hero) => hero.uid === id);

          // Автор з URL теж підтягується без автоматичного скролу
          setSelectedHero(selected || heroData[0]);
        }
      } catch (error) {
        console.error("Помилка отримання авторів:", error);
      }
    };

    fetchHeroes();
  }, [id]);

  const scrollToSelectedHero = (hero) => {
    if (!hero) return;

    requestAnimationFrame(() => {
      // Горизонтальний скрол списку авторів
      if (scrollRef.current) {
        const selectedElement = scrollRef.current.querySelector(
          `[data-uid='${hero.uid}']`,
        );

        if (selectedElement) {
          selectedElement.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "center",
          });
        }
      }

      // Вертикальний скрол саме до імені автора
      if (heroNameRef.current) {
        const top =
          heroNameRef.current.getBoundingClientRect().top +
          window.pageYOffset -
          200;

        window.scrollTo({
          top,
          behavior: "smooth",
        });
      }
    });
  };

  const handleHeroSelect = (hero) => {
    if (!hero) return;

    // Якщо користувач натиснув на вже вибраного автора,
    // selectedHero не зміниться, тому запускаємо скрол вручну
    if (selectedHero?.uid === hero.uid) {
      scrollToSelectedHero(hero);
      return;
    }

    shouldScrollAfterSelect.current = true;
    setSelectedHero(hero);
  };

  useEffect(() => {
    if (!selectedHero) return;

    // Якщо автора вибрало автоматично при першому завантаженні — не скролимо
    if (!shouldScrollAfterSelect.current) return;

    scrollToSelectedHero(selectedHero);

    shouldScrollAfterSelect.current = false;
  }, [selectedHero]);

  useEffect(() => {
    if (!selectedHero?.name) return;

    const getArrayValue = (value) => {
      if (Array.isArray(value)) return value;

      if (typeof value === "string" && value.trim() !== "") {
        return [value];
      }

      return [];
    };

    const getAuthorsBySurname = (value) => {
      return getArrayValue(value)
        .map((item) => item.split(" ")[0]?.trim())
        .filter(Boolean);
    };

    const isActiveByDate = (item) => {
      const now = new Date();

      const start = item.startDate ? new Date(item.startDate) : null;
      const end = item.endDate ? new Date(item.endDate) : null;

      if (start && now < start) return false;
      if (end && now > end) return false;

      return true;
    };

    const isProductInAppliesTo = (product, appliesTo = {}) => {
      const productSeries = [
        ...getArrayValue(product.seria),
        ...getArrayValue(product.series),
      ];

      const productAuthors = getAuthorsBySurname(product.textAutor);

      const matchProduct =
        Array.isArray(appliesTo.products) &&
        appliesTo.products.some(
          (pid) => pid === product.uid || pid === product.id,
        );

      const matchSeries =
        Array.isArray(appliesTo.series) &&
        productSeries.some((ser) => appliesTo.series.includes(ser));

      const actionAuthors = Array.isArray(appliesTo.authors)
        ? appliesTo.authors
            .map((author) => author.split(" ")[0]?.trim())
            .filter(Boolean)
        : [];

      const matchAuthor = productAuthors.some((author) =>
        actionAuthors.includes(author),
      );

      return matchProduct || matchSeries || matchAuthor;
    };

    const applyDiscountsToProduct = (product, sales, actions) => {
      let updatedProduct = { ...product };

      const matchedSale = sales.find((sale) => {
        return (
          isActiveByDate(sale) &&
          isProductInAppliesTo(updatedProduct, sale.appliesTo)
        );
      });

      if (matchedSale) {
        const discount = Number(matchedSale.discountPercent) || 0;
        const basePrice = Number(updatedProduct.price) || 0;
        const newPrice = Math.round(basePrice - (basePrice * discount) / 100);

        updatedProduct = {
          ...updatedProduct,
          saleDiscountPercent: discount,
          salePrice: newPrice,
        };
      }

      const matchedAction = actions.find((action) => {
        return (
          isActiveByDate(action) &&
          isProductInAppliesTo(updatedProduct, action.appliesTo)
        );
      });

      if (matchedAction) {
        const discount = Number(matchedAction.discountPercent) || 0;
        const basePrice = Number(updatedProduct.price) || 0;
        const newPrice = Math.round(basePrice - (basePrice * discount) / 100);

        updatedProduct = {
          ...updatedProduct,
          actionDiscountPercent: discount,
          actionPrice: newPrice,
        };
      }

      return updatedProduct;
    };

    const fetchProducts = async () => {
      try {
        const [productsSnapshot, salesSnapshot, actionsSnapshot] =
          await Promise.all([
            getDocs(collection(db, "product")),
            getDocs(collection(db, "sales")),
            getDocs(collection(db, "actions")),
          ]);

        const allProducts = productsSnapshot.docs
          .map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }))
          .filter(isProductVisible);

        const sales = salesSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        const actions = actionsSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        const productsWithDiscounts = allProducts.map((product) =>
          applyDiscountsToProduct(product, sales, actions),
        );

        const selectedNameFirstWord = selectedHero.name
          .split(" ")[0]
          .trim()
          .toLowerCase();

        const filtered = productsWithDiscounts.filter((product) => {
          if (!isProductVisible(product)) {
            return false;
          }

          const productAuthors = getAuthorsBySurname(product.textAutor).map(
            (author) => author.toLowerCase(),
          );

          return productAuthors.includes(selectedNameFirstWord);
        });

        setProducts(filtered);
      } catch (error) {
        console.error("❌ Помилка отримання книг автора:", error);
      }
    };

    fetchProducts();
  }, [selectedHero]);

  const scrollLeft = () =>
    scrollRef.current?.scrollBy({ left: -300, behavior: "smooth" });

  const scrollRight = () =>
    scrollRef.current?.scrollBy({ left: 300, behavior: "smooth" });
  const getYoutubeVideoId = (value) => {
    if (!value) return "";

    const videoValue = String(value).trim();

    if (videoValue.includes("youtube.com/watch?v=")) {
      return videoValue.split("v=")[1]?.split("&")[0] || "";
    }

    if (videoValue.includes("youtu.be/")) {
      return videoValue.split("youtu.be/")[1]?.split("?")[0] || "";
    }

    if (videoValue.includes("youtube.com/embed/")) {
      return videoValue.split("embed/")[1]?.split("?")[0] || "";
    }

    if (videoValue.includes("youtube.com/shorts/")) {
      return videoValue.split("shorts/")[1]?.split("?")[0] || "";
    }

    return videoValue;
  };
  return (
    <div>
      <div className={css.allBooksWrap}>
        <div className={css.allHero}>
          <p className={css.yourPerfectHero}>
            Майстри, яких представляє видавництво “Час майстрів”
            <br />
            <span className={css.yourPerfectHeroSpan}>
              відкриті до безпосереднього спілкування з дітьми, батьками та
              спеціалістами
            </span>
          </p>

          <div className={css.ageWrap}>
            <div className={css.chousBooksSelect}>
              <select
                className={css.customSelect}
                value={
                  selectedHero
                    ? heroes.findIndex((hero) => hero.uid === selectedHero.uid)
                    : ""
                }
                onChange={(e) => {
                  const hero = heroes[Number(e.target.value)];
                  handleHeroSelect(hero);
                }}
              >
                {heroes.map((hero, index) => (
                  <option key={index} className={css.customOpin} value={index}>
                    {hero.name}
                  </option>
                ))}
              </select>

              <img
                src={arrowImp}
                className={css.customArrowSelect}
                alt="Arrow"
              />
            </div>
          </div>
        </div>

        <div className={css.autorListSmal}>
          <img
            src={arrowLeft}
            onClick={scrollLeft}
            className={css.arrowLeftSt}
            alt="Scroll Left"
          />

          <div className={css.autorListSmalNew} ref={scrollRef}>
            {heroes.map((hero, index) => (
              <div
                key={index}
                data-uid={hero.uid}
                onClick={() => handleHeroSelect(hero)}
                className={css.imgAutorWrapSmall}
              >
                <img
                  src={hero.foto}
                  className={`${css.imgAutorSmall} ${
                    selectedHero?.uid === hero.uid ? css.selectedHeroImage : ""
                  }`}
                  alt={hero.name}
                />

                <p className={css.autorNameM}>{hero.name}</p>
                <p className={css.autorNameMSma}>{hero.book}</p>
                {/* <p className={css.autorNameMbigCol}>{hero.descSecond}</p> */}
              </div>
            ))}
          </div>

          <img
            src={arrowRight}
            onClick={scrollRight}
            className={css.arrowRightSt}
            alt="Scroll Right"
          />
        </div>
      </div>

      {selectedHero && (
        <div className={css.wrapHeroBigFoto}>
          <div className={css.wrapHeroBigFotoTwo}>
            <div className={css.imgAutorWrapBig}>
              <img
                src={selectedHero.foto}
                className={css.imgAutorBig}
                alt="Author"
              />
            </div>

            <div className={css.descHeroOP}>
              <h1 className={css.heroName} ref={heroNameRef}>
                {selectedHero.name}
              </h1>

              <p className={css.dotP}>{selectedHero.descOne}</p>
              <p className={css.dotP}>{selectedHero.descSecond}</p>

              <p className={css.whatBook}>
                {selectedHero.autor}&nbsp; {selectedHero.book}
              </p>
            </div>
          </div>

          <div className={css.yellowFitchWrap}>
            <p className={css.yellowFitchWrapP}>{selectedHero.smallDesc}</p>
            <div className={css.hvist}></div>
          </div>

          <div className={css.historiCreateBlock}>
            <p className={css.hictoryP}>{selectedHero.history}</p>
          </div>

          <div className={css.blockInturv}>
            <div className={css.blockInturvSmall}>
              <h3 className={css.inturvH3}>Інтерв’ю з автором</h3>
              <p className={css.inturvP}>{selectedHero.internOne}</p>
              <p className={css.inturvP}>{selectedHero.internSecond}</p>
            </div>
          </div>
        </div>
      )}

      <div className={css.theSameBooksWrap}>
        <div className={css.theSameBooksWrapSmall}>
          <h4 className={css.theSameH4}>Книги автора</h4>

          <div className={css.smallBookLikeWrap}>
            {products.slice(0, 3).map((el, index) => (
              <ProductForHero el={el} key={index} />
            ))}
          </div>
        </div>
      </div>

      <div className={css.videoBlockWrap}>
        <div className={css.videoBlockWrapSmall}>
          <h4 className={css.seeBook}>Відеознайомство</h4>
          <div className={css.video}>
            {selectedHero?.video && (
              <YouTube
                key={selectedHero.video}
                videoId={getYoutubeVideoId(selectedHero.video)}
                className={css.youtubeWrap}
                iframeClassName={css.youtubeFrame}
              />
            )}
          </div>
        </div>
      </div>

      <LitShow />
      <Footer />
    </div>
  );
}
